import React from "react";
// import ReactTooltip from "react-tooltip";
import "./account-nav.css";
import {
  gotoLogInPage,
  gotoLogOutPage,
  openPersonalCenter,
  getWhetherLogin
} from "../../lib/xes/xes";
import bindAll from "lodash.bindall";
import http from "../../http";

class AccountNav extends React.Component {
  constructor(props) {
    super(props);
    bindAll(this, ["handleLogIn", "handleLogOut", "logIn", "handleNameClick"]);
    this.state = {
      userName: "",
      isLogIn: false,
      isShowTooltip: false
    };
    this.logIn();
  }
  logIn() {
    http
      .getUserInfo()
      .then(data => {
        this.setState({
          userName: data.realname,
          isLogIn: true
        });
      })
      .catch(e => {
        console.warn("can not get user info");
      });
  }
  handleLogIn() {
    gotoLogInPage();
    let logTimer = window.setInterval(() => {
      if (getWhetherLogin()) {
        this.logIn();
        window.clearInterval(logTimer);
      }
    }, 200);
  }
  handleLogOut() {
    gotoLogOutPage();
  }
  handleNameClick() {
    this.setState(function(state) {
      return {
        isShowTooltip: !state.isShowTooltip
      };
    });
  }
  render() {
    const { isShowTooltip } = this.state;
    return (
      <div>
        {this.state.isLogIn ? (
          <div className="tooltip-wrap">
            <span
              className="user-name"
              data-tip="custom show"
              data-event="click"
              data-for="xes-account-nav"
              onClick={this.handleNameClick}
            >
              {this.state.userName}
            </span>
            {isShowTooltip && (
              <div className="tooltip">
                <div className="pointer" onClick={openPersonalCenter}>
                  作品管理
                </div>
                <div className="pointer" onClick={this.handleLogOut}>
                  退出
                </div>
              </div>
            )}
          </div>
        ) : (
          <div>
            <span onClick={this.handleLogIn} className="pointer">
              登录
            </span>
          </div>
        )}
      </div>
    );
  }
}

export default AccountNav;
